export default "__VITE_ASSET__BCWO0LYo__"